/***
 * Created on 2025/4/30
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React, {useState} from 'react';

function UserAvatarIcon({user_info, with_user_info=false, avatar_class='account-img'}) {
    const [imageError, setImageError] = useState(false);

    // Extract user data
    const avatarUrl = user_info?.avatars?.small || user_info?.avatar || `${window._env_.REACT_APP_ACC_URL}/avatar/${user_info?.id}/s`;
    const displayName = user_info?.display_name || user_info?.name || '';
    const initial = displayName.charAt(0).toUpperCase();

    // Handle image load error
    const handleImageError = () => {
        setImageError(true);
    };

    return (
        <>
            <div className={avatar_class}>
                <div className={`avatar ${(!avatarUrl || imageError) ? 'no-avatar' : ''}`}>
                    {avatarUrl && !imageError ? (
                        <img
                            src={avatarUrl}
                            alt={displayName || 'User avatar'}
                            onError={handleImageError}
                        />
                    ) : (
                        initial && <span>{initial}</span>
                    )}
                </div>
            </div>
            {with_user_info && (
                <div className="account-info">
                    <div className="name">{displayName}</div>
                    <div className="mail">{user_info?.email}</div>
                </div>
            )}
        </>
    );
}

export default UserAvatarIcon;